var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookHoverLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 25,
    viewBox: "0 0 13 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.14521 24.4798V12.622H0.180766V8.54591H3.14521V6.13731C3.14521 4.31541 3.48488 2.97215 4.16423 2.10752C4.84358 1.21201 6.10965 0.764258 7.96242 0.764258H12.0385V4.84036H9.21304C8.50281 4.84036 8.05506 4.96388 7.86978 5.21092C7.68451 5.45795 7.59187 5.89027 7.59187 6.50786V8.54591H12.0385L11.6217 12.622H7.59187V24.4798H3.14521Z",
    fill: "#3C9C75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookHoverLogo);
export default __webpack_public_path__ + "static/media/FacebookHoverLogo.b9c9687a77fe7838663f88c5e5f3e5b6.svg";
export { ForwardRef as ReactComponent };